import * as Y from 'yjs';
import { CollectionContent, yarrayFromArray } from '.';

export function createDocumentForCollection(collection: CollectionContent): Y.Doc {
    const doc = new Y.Doc();

    const collectionMap = doc.getMap('collection');
    collectionMap.set('id', collection.id);
    collectionMap.set('spaceId', collection.spaceId);
    collectionMap.set('properties', yarrayFromArray(collection.properties));

    return doc;
}
